/**
 * EditorStateService - 에디터 상태 관리 서비스
 * Single Responsibility: Store 접근과 상태 관리 로직 캡슐화
 */

import { get } from 'svelte/store'
import { errorStore } from '$lib/stores/grammar'
import { aiSuggestionsStore } from '$lib/stores/aiSuggestions'

export class EditorStateService {
  /**
   * 에러 상태 초기화
   * 모든 에러와 AI 제안을 클리어
   */
  static clearErrors(): void {
    // 에러 스토어 초기화
    errorStore.set({
      errors: [],
      ignoredErrors: new Set(),
      appliedCorrections: new Map(),
      activeErrorId: null
    })
    
    // AI 제안 클리어
    aiSuggestionsStore.clearComments()
  }
  
  /**
   * 현재 에러 상태 가져오기
   */
  static getErrorState() {
    return get(errorStore)
  }
  
  /**
   * 에러가 있는지 확인
   */
  static hasErrors(): boolean {
    const state = get(errorStore)
    return state.errors.length > 0
  }
  
  /**
   * 활성 에러(무시되지 않은) 개수 가져오기
   */
  static getActiveErrorCount(): number {
    const state = get(errorStore)
    return state.errors.filter(
      error => !state.ignoredErrors.has(error.id)
    ).length
  }
}